import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
  type RemoteConfig,
} from 'firebase/remote-config'

import { initFirebaseApp } from './firebase'

/**
 * 앱과 같은 리모트 컨피그를 웹에서도 읽는다.
 * 상품 유의사항·광고 문구처럼 운영이 콘솔에서 바꾸는 값이 여기에 들어 있다.
 */
let remoteConfig: RemoteConfig | undefined
let activatePromise: Promise<RemoteConfig | undefined> | null = null

const initRemoteConfig = async (): Promise<RemoteConfig | undefined> => {
  if (typeof window === 'undefined') return undefined
  if (remoteConfig) return remoteConfig
  if (activatePromise) return activatePromise

  activatePromise = (async () => {
    const app = await initFirebaseApp()
    if (!app) return undefined

    const config = getRemoteConfig(app)
    await fetchAndActivate(config)
    remoteConfig = config

    return config
  })()

  return activatePromise
}

/** 리모트 컨피그 문자열 값. 키가 없으면 빈 문자열 */
const getRemoteConfigString = async (key: string): Promise<string> => {
  const config = await initRemoteConfig()
  if (!config) return ''

  return getValue(config, key).asString()
}

/** JSON 으로 저장된 리모트 컨피그 값. 비었거나 형식이 깨지면 null */
export const getRemoteConfigJson = async <T>(
  key: string
): Promise<T | null> => {
  const raw = await getRemoteConfigString(key)
  if (!raw) return null

  try {
    return JSON.parse(raw) as T
  } catch {
    // 콘솔에서 잘못 저장된 값 때문에 화면 전체가 죽지 않게 한다
    return null
  }
}
